import ProductssBanner from "./Productss-Banner/ProductssBanner";
import ProductssSolu from "./Productss-Solu/ProductssSolu";
import ProductssMainof from "./Productss-Mainof/ProductssMainof";
import WhyChosePro from "./WhyChose-Pro/WhyChosePro";
import Cooperate from "../Cooperate/Cooperate";
import Evaluate from "../Business-Partner/Evaluate/Evaluate";
import Contact from "../Contact/Contact";
export default function Productss() {
  return (
    <div className="w-full">
      <ProductssBanner />
      <div className="container w-full mx-auto p-3">
        <ProductssSolu />
        <ProductssMainof />
        <WhyChosePro />
        <Cooperate />
        <Evaluate />
      </div>
      <Contact />
    </div>
  );
}
